<template>
  <div class="app-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="待审核商品" name="pending">
        <el-card>
          <div slot="header" class="clearfix">
            <span>待审核商品列表 (共 {{ pendingPage.total }} 件商品)</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleRefresh">刷新</el-button>
          </div>
          <!-- 待审核商品搜索框 -->
          <div style="margin-bottom: 20px;">
            <el-form :inline="true" :model="pendingSearchForm" class="demo-form-inline">
              <el-form-item label="商品名称">
                <el-input v-model="pendingSearchForm.title" placeholder="请输入商品名称" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handlePendingSearch">查询</el-button>
                <el-button @click="handlePendingReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
              :data="pendingList"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="加载中">
            <el-table-column prop="id" label="商品ID" width="80"></el-table-column>
            <el-table-column label="商品图片" width="100">
              <template slot-scope="scope">
                <el-image 
                  :src="scope.row.picUrl" 
                  fit="cover" 
                  style="width: 60px; height: 60px"
                  :preview-src-list="[scope.row.picUrl]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="商品名称"></el-table-column>
            <el-table-column prop="price" label="价格" width="100"></el-table-column>
            <el-table-column prop="stock" label="库存" width="80"></el-table-column>
            <el-table-column label="类型" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type == 0 || scope.row.type == '0'" type="success">私域</el-tag>
                <el-tag v-else-if="scope.row.type == 1 || scope.row.type == '1'" type="warning">公域</el-tag>
                <span v-else>未知({{ scope.row.type }})</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0 || scope.row.status == '0' || scope.row.status == '待审核'" type="primary">待审核</el-tag>
                <el-tag v-else-if="scope.row.status == 1 || scope.row.status == '1' || scope.row.status == '已通过'" type="success">已通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2 || scope.row.status == '2' || scope.row.status == '已拒绝'" type="danger">已拒绝</el-tag>
                <el-tag v-else-if="scope.row.status == -1 || scope.row.status == '-1' || scope.row.status == '不加入商品池不审核'" type="info">不加入商品池不审核</el-tag>
                <el-tag v-else type="info">未知({{ scope.row.status }})</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="approve(scope.row)">通过</el-button>
                <el-button size="mini" type="danger" @click="reject(scope.row)">拒绝</el-button>
                <el-button size="mini" @click="viewDetail(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 添加分页组件 -->
          <el-pagination
            @size-change="handlePendingSizeChange"
            @current-change="handlePendingCurrentChange"
            :current-page="pendingPage.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pendingPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pendingPage.total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-tab-pane>
      
      <el-tab-pane label="已审核商品" name="reviewed">
        <el-card>
          <div slot="header" class="clearfix">
            <span>已审核商品列表 (共 {{ reviewedPage.total }} 件商品)</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="handleRefresh">刷新</el-button>
          </div>
          <!-- 已审核商品搜索框 -->
          <div style="margin-bottom: 20px;">
            <el-form :inline="true" :model="reviewedSearchForm" class="demo-form-inline">
              <el-form-item label="商品名称">
                <el-input v-model="reviewedSearchForm.title" placeholder="请输入商品名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="审核状态">
                <el-select v-model="reviewedSearchForm.status" placeholder="请选择审核状态" clearable>
                  <el-option label="已通过" value="1"></el-option>
                  <el-option label="已拒绝" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleReviewedSearch">查询</el-button>
                <el-button @click="handleReviewedReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
              :data="reviewedList"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="加载中">
            <el-table-column prop="id" label="商品ID" width="80"></el-table-column>
            <el-table-column label="商品图片" width="100">
              <template slot-scope="scope">
                <el-image 
                  :src="scope.row.picUrl" 
                  fit="cover" 
                  style="width: 60px; height: 60px"
                  :preview-src-list="[scope.row.picUrl]">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="商品名称"></el-table-column>
            <el-table-column prop="price" label="价格" width="100"></el-table-column>
            <el-table-column prop="stock" label="库存" width="80"></el-table-column>
            <el-table-column label="类型" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type == 0 || scope.row.type == '0'" type="success">私域</el-tag>
                <el-tag v-else-if="scope.row.type == 1 || scope.row.type == '1'" type="warning">公域</el-tag>
                <span v-else>未知({{ scope.row.type }})</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0 || scope.row.status == '0' || scope.row.status == '待审核'" type="primary">待审核</el-tag>
                <el-tag v-else-if="scope.row.status == 1 || scope.row.status == '1' || scope.row.status == '已通过'" type="success">已通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2 || scope.row.status == '2' || scope.row.status == '已拒绝'" type="danger">已拒绝</el-tag>
                <el-tag v-else-if="scope.row.status == -1 || scope.row.status == '-1' || scope.row.status == '不加入商品池不审核'" type="info">不加入商品池不审核</el-tag>
                <el-tag v-else type="info">未知({{ scope.row.status }})</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="warning" @click="withdraw(scope.row)">撤回</el-button>
                <el-button size="mini" @click="viewDetail(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 添加分页组件 -->
          <el-pagination
            @size-change="handleReviewedSizeChange"
            @current-change="handleReviewedCurrentChange"
            :current-page="reviewedPage.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="reviewedPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="reviewedPage.total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    
    <!-- 商品详情弹窗 -->
    <el-dialog title="商品详情" :visible.sync="detailDialogVisible" width="60%">
      <div v-if="currentGoods">
        <el-row>
          <el-col :span="12">
            <el-image 
              :src="currentGoods.picUrl" 
              fit="cover" 
              style="width: 200px; height: 200px">
            </el-image>
          </el-col>
          <el-col :span="12">
            <p><strong>商品名称：</strong>{{ currentGoods.title }}</p>
            <p><strong>商品ID：</strong>{{ currentGoods.id }}</p>
            <p><strong>价格：</strong>{{ currentGoods.price }}</p>
            <p><strong>库存：</strong>{{ currentGoods.stock }}</p>
            <p><strong>类型：</strong>
              <el-tag v-if="currentGoods.type == 0 || currentGoods.type == '0'" type="success">私域</el-tag>
              <el-tag v-else-if="currentGoods.type == 1 || currentGoods.type == '1'" type="warning">公域</el-tag>
              <el-tag v-else>未知({{ currentGoods.type }})</el-tag>
            </p>
            <p><strong>审核状态：</strong>
              <el-tag v-if="currentGoods.status == 0 || currentGoods.status == '0' || currentGoods.status == '待审核'" type="primary">待审核</el-tag>
              <el-tag v-else-if="currentGoods.status == 1 || currentGoods.status == '1' || currentGoods.status == '已通过'" type="success">已通过</el-tag>
              <el-tag v-else-if="currentGoods.status == 2 || currentGoods.status == '2' || currentGoods.status == '已拒绝'" type="danger">已拒绝</el-tag>
              <el-tag v-else-if="currentGoods.status == -1 || currentGoods.status == '-1' || currentGoods.status == '不加入商品池不审核'" type="info">不加入商品池不审核</el-tag>
              <el-tag v-else type="info">未知({{ currentGoods.status }})</el-tag>
            </p>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <p><strong>商品描述：</strong></p>
            <div v-html="currentGoods.detail"></div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getPendingReviewListApi, 
  getReviewedListApi, 
  approveGoodsApi, 
  rejectGoodsApi,
  revokeGoodsApi,
  withdrawGoodsApi
} from '@/api/goodsReviewApi'

export default {
  name: 'GoodsReview',
  data() {
    return {
      activeTab: 'pending',
      loading: false,
      pendingList: [],
      reviewedList: [],
      detailDialogVisible: false,
      currentGoods: null,
      pendingSearchForm: {
        title: ''
      },
      reviewedSearchForm: {
        title: '',
        status: '2'
      },
      pendingPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      reviewedPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    // 添加一个小延迟，确保组件完全初始化后再获取数据
    this.$nextTick(() => {
      setTimeout(() => {
        this.fetchPendingList()
      }, 100)
    })
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'pending') {
        this.fetchPendingList()
      } else if (tab.name === 'reviewed') {
        this.fetchReviewedList()
      }
    },
    
    handlePendingSearch() {
      this.pendingPage.currentPage = 1
      this.fetchPendingList()
    },
    
    handlePendingReset() {
      this.pendingSearchForm.title = ''
      this.pendingPage.currentPage = 1
      this.fetchPendingList()
    },
    
    handleReviewedSearch() {
      this.reviewedPage.currentPage = 1
      this.fetchReviewedList()
    },
    
    handleReviewedReset() {
      this.reviewedSearchForm.title = ''
      this.reviewedSearchForm.status = ''
      this.reviewedPage.currentPage = 1
      this.fetchReviewedList()
    },
    
    // 处理待审核商品分页大小变化
    handlePendingSizeChange(val) {
      this.pendingPage.pageSize = val
      this.pendingPage.currentPage = 1
      this.fetchPendingList()
    },
    
    // 处理待审核商品当前页变化
    handlePendingCurrentChange(val) {
      this.pendingPage.currentPage = val
      this.fetchPendingList()
    },
    
    // 处理已审核商品分页大小变化
    handleReviewedSizeChange(val) {
      this.reviewedPage.pageSize = val
      this.reviewedPage.currentPage = 1
      this.fetchReviewedList()
    },
    
    // 处理已审核商品当前页变化
    handleReviewedCurrentChange(val) {
      this.reviewedPage.currentPage = val
      this.fetchReviewedList()
    },
    
    async fetchPendingList() {
      this.loading = true
      try {
        const params = {
          current: this.pendingPage.currentPage,
          size: this.pendingPage.pageSize,
          status: 0,  // 0=待审核
          title: this.pendingSearchForm.title || undefined
        }
        
        const res = await getPendingReviewListApi(params)
        console.log(res)
        // 更安全的数据访问方式
        if (res && res.data) {
          this.pendingList = res.data.records || res.data.rows || res.data.list || []
          // 使用total字段来显示商品总数
          this.pendingPage.total = res.data.total || res.data.totalCount || 0
          
          // 如果没有数据但total为0，确保列表为空
          if (!this.pendingList.length && this.pendingPage.total === 0) {
            this.pendingList = []
          }
        } else {
          this.pendingList = []
          this.pendingPage.total = 0
        }
      } catch (err) {
        console.error('获取待审核商品列表失败:', err)
        // 检查是否有网络错误信息
        let errorMsg = '获取待审核商品列表失败';
        if (err && err.message) {
          errorMsg += ': ' + err.message;
        } else if (err && err.msg) {
          errorMsg += ': ' + err.msg;
        }
        this.$message.error(errorMsg)
        this.pendingList = []
        this.pendingPage.total = 0
      } finally {
        this.loading = false
      }
      console.log(this.pendingPage)
    },
    
    async fetchReviewedList() {
      this.loading = true
      try {
        // 构造查询参数，默认只查询已审核的商品（状态为1或2）
        const params = {
          current: this.reviewedPage.currentPage,
          size: this.reviewedPage.pageSize,
          title: this.reviewedSearchForm.title || undefined,
          status: this.reviewedSearchForm.status || undefined
        }
        
        // 如果没有指定状态，则默认只显示已审核状态(1或2)的商品，排除状态0(待审核)的商品
        // 当用户没有手动选择状态时，如果当前状态为空或者为默认值'2'，则保持原样，否则使用'1,2'
        if (!params.status) {
          params.status = '1,2' // 只查询已通过和已拒绝的商品
        }
        
        const res = await getReviewedListApi(params)
        console.log(res,123123)
        
        // 更安全的数据访问方式
        if (res && res.data) {
          this.reviewedList = res.data.records || res.data.rows || res.data.list || []
          // 使用total字段来显示商品总数
          this.reviewedPage.total = res.data.total
          console.log(res.data.total)
        } else {
          this.reviewedList = []
          this.reviewedPage.total = 0
        }
        
        // 如果没有数据但total为0，确保列表为空
        if (!this.reviewedList.length && this.reviewedPage.total === 0) {
          this.reviewedList = []
        }
      } catch (err) {
        console.error('获取已审核商品列表失败:', err)
        // 检查是否有网络错误信息
        let errorMsg = '获取已审核商品列表失败';
        if (err && err.message) {
          errorMsg += ': ' + err.message;
        } else if (err && err.msg) {
          errorMsg += ': ' + err.msg;
        }
        this.$message.error(errorMsg)
        this.reviewedList = []
        this.reviewedPage.total = 0
      } finally {
        this.loading = false
      }
    },
    
    // 添加刷新功能
    handleRefresh() {
      if (this.activeTab === 'pending') {
        this.fetchPendingList()
      } else {
        this.fetchReviewedList()
      }
    },
    
    async approve(row) {
      try {
        await this.$confirm('确认通过该商品的审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 使用正确的参数格式调用API
        const params = {
          id: row.id,
          status: 1  // 1表示审核通过
        }
        const res = await approveGoodsApi(params)
        if (res.code !== 200) {
          throw new Error(res.msg || '审核通过失败')
        }
        this.$message.success('审核通过成功')
        // 刷新两个列表，确保数据同步
        await this.fetchPendingList()
        await this.fetchReviewedList()
      } catch (err) {
        if (err !== 'cancel') {
          console.error('审核通过失败:', err)
          this.$message.error('审核通过失败: ' + (err.msg || err.message || '未知错误'))
        }
      }
    },
    
    async reject(row) {
      try {
        await this.$confirm('确认拒绝该商品的审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 使用正确的参数格式调用API
        const params = {
          id: row.id,
          status: 2  // 2表示审核拒绝
        }
        const res = await rejectGoodsApi(params)
        if (res.code !== 200) {
          throw new Error(res.msg || '审核拒绝失败')
        }
        this.$message.success('审核拒绝成功')
        // 刷新两个列表，确保数据同步
        await this.fetchPendingList()
        await this.fetchReviewedList()
      } catch (err) {
        if (err !== 'cancel') {
          console.error('审核拒绝失败:', err)
          this.$message.error('审核拒绝失败: ' + (err.msg || err.message || '未知错误'))
        }
      }
    },
    
    async revoke(row) {
      try {
        await this.$confirm('确认撤回该商品的审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 使用正确的参数格式调用API
        const params = {
          id: row.id,
          status: 0  // 0表示撤回审核，回到待审核状态
        }
        const res = await revokeGoodsApi(params)
        if (res.code !== 200) {
          throw new Error(res.msg || '撤回失败')
        }
        this.$message.success('撤回成功')
        // 刷新两个列表，确保数据同步
        await this.fetchPendingList()
        await this.fetchReviewedList()
      } catch (err) {
        if (err !== 'cancel') {
          console.error('撤回失败:', err)
          this.$message.error('撤回失败: ' + (err.msg || err.message || '未知错误'))
        }
      }
    },
    
    async withdraw(row) {
      try {
        await this.$confirm('确认撤回该商品的审核状态? 撤回后商品将回到待审核状态。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 使用与revoke相同的方式调用API，但传递正确的参数
        const params = {
          id: row.id,
          status: 0  // 0表示撤回审核，回到待审核状态
        }
        const res = await withdrawGoodsApi(params)
        if (res.code !== 200) {
          throw new Error(res.msg || '撤回失败')
        }
        this.$message.success('撤回成功')
        // 刷新两个列表，确保数据同步
        await this.fetchPendingList()
        await this.fetchReviewedList()
        // 不再自动切换标签页，让用户可以继续操作
      } catch (err) {
        if (err !== 'cancel') {
          console.error('撤回失败:', err)
          this.$message.error('撤回失败: ' + (err.msg || err.message || '未知错误'))
        }
      }
    },
    
    viewDetail(row) {
      this.currentGoods = row
      this.detailDialogVisible = true
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>